


const formatAmount = (amount) => {
  return new Intl.NumberFormat('en-Gh', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
}


export default formatAmount;